// extracted by mini-css-extract-plugin
module.exports = {"tabBar":"styles-module__tabBar___2ZR8t","explore":"styles-module__explore___3qbIF","tab":"styles-module__tab___2SzFx","active":"styles-module__active___1DTm2"};